export interface Step {
  id: string;
  title: string;
  description: string;
  contentFileiOS: string;
  contentFileAndroid: string;
  path: string;
}

export const steps: Step[] = [
  {
    id: 'obezbedi',
    title: 'Obezbedi',
    description: 'Kako zaključati telefon da se dušmani namuče da ga otvore',
    contentFileiOS: 'step-1-welcome-ios.md',
    contentFileAndroid: 'step-1-welcome-android.md',
    path: '/obezbedi',
  },
  {
    id: 'fotografije',
    title: 'Fotografije',
    description: 'Kako da zaštitite svoje fotografije sa protesta ',
    contentFileiOS: 'step-2-slike-ios.md',
    contentFileAndroid: 'step-2-slike-android.md',
    path: '/fotografije',
  },
  {
    id: 'filmici',
    title: 'Filmići',
    description: 'Direktan prenos nasilja, ne samo uspomena sa protesta',
    contentFileiOS: 'step-3-filmici-ios.md',
    contentFileAndroid: 'step-3-filmici-android.md',
    path: '/filmici',
  },
  {
    id: 'dodatne',
    title: 'Dodatne mere',
    description: 'Za svaki slučaj',
    contentFileiOS: 'step-4-dodatne-mere-ios.md',
    contentFileAndroid: 'step-4-dodatne-mere-android.md',
    path: '/dodatne',
  },
];

export const getStepByPath = (path: string): Step | undefined => {
  return steps.find(step => step.path === path);
};

export const getStepIndex = (stepId: string): number => {
  return steps.findIndex(step => step.id === stepId);
};

export const getNextStep = (currentStepId: string): Step | undefined => {
  const currentIndex = getStepIndex(currentStepId);
  return currentIndex >= 0 && currentIndex < steps.length - 1
    ? steps[currentIndex + 1]
    : undefined;
};

export const getPreviousStep = (currentStepId: string): Step | undefined => {
  const currentIndex = getStepIndex(currentStepId);
  return currentIndex > 0 ? steps[currentIndex - 1] : undefined;
};
